import { defaultTheme } from '@design-system/styles/themes/default'
import type { DSThemeDefinition } from '@design-system/styles/themes/types'
import { variablesLight } from '@tenable/paladin-style-dictionary'

const tokens: Partial<DSThemeDefinition['tokens']> = {
  /**
   * Blade
   */

  'blade/backgroundColor/default':
    variablesLight.color.colorBackgroundSecondary,

  /**
   * Card
   */

  'card/borderRadius/default': '',
  'card/borderRadius/large': variablesLight.borderRadius.radiusL,
  'card/boxShadow/light': variablesLight.boxShadow.boxShadowContainerSmall,
  'card/boxShadow/default': variablesLight.boxShadow.shadowDepth1,
  'card/color/backgroundWhite': variablesLight.color.colorBackgroundPrimary,
  'card/color/border/default': variablesLight.border.borderContainerPrimary,
  'card/margin/mainContent': variablesLight.spacing.space500,
  'card/padding/default': variablesLight.spacing.spacingM,
  'card/padding/mainContent': variablesLight.spacing.space800,

  /**
   * HeadBar
   */

  'headBar/color/background': variablesLight.color.colorBackgroundTertiary,
  'headBar/color/bodyBackgroundN':
    variablesLight.color.colorBackgroundSecondary,

  /**
   * HealthCheck
   */

  'healthCheck/color/failure': variablesLight.color.colorForegroundStatusBad,
  'healthCheck/color/success': variablesLight.color.colorForegroundStatusGood,
  'healthCheck/color/unknown':
    variablesLight.color.colorBackgroundButtonDisabled,
  'healthCheck/color/warning':
    variablesLight.color.colorForegroundStatusWarning,

  /**
   * Label
   */

  'label/color/text': variablesLight.color.colorTextPrimary,

  /**
   * MainMenu
   */

  'mainMenu/padding/default': `${variablesLight.spacing.spacingL} 10px`,
  'mainMenu/width/default': '56px',
  'mainMenu/group/border-radius/default': variablesLight.borderRadius.radius250,
  'mainMenu/group/color/background':
    variablesLight.color.colorBackgroundSecondary,
  'mainMenu/link/border-radius': variablesLight.borderRadius.radius250,
  'mainMenu/link/color/background':
    variablesLight.color.colorBackgroundSecondary,
  'mainMenu/link/color/backgroundHover':
    variablesLight.color.colorBackgroundButtonPrimaryHover,
  'mainMenu/link/color/backgroundActive':
    variablesLight.color.colorBackgroundButtonPrimaryIdle,
  'mainMenu/link/color/text': variablesLight.color.colorForegroundTertiary,
  'mainMenu/link/color/textHover':
    variablesLight.color.colorForegroundButtonPrimaryHover,
  'mainMenu/link/color/textActive':
    variablesLight.color.colorForegroundButtonPrimaryHover,
  'mainMenu/link/padding/default': variablesLight.spacing.spacingM,
  'mainMenu/menuEntry/padding/background': 3,
  'mainMenu/menuEntry/width/default': '36px',
  'mainMenu/menuEntry/width/expanded': '275px',
  'mainMenu/menuEntry/width/expandedWithoutPadding': '185px'
}

export const paladinThemeTokens: DSThemeDefinition = {
  ...defaultTheme,
  tokens: { ...defaultTheme.tokens, ...tokens }
}
